import { UsCbpEntryReleaseStatus } from '@xbcb/work-order-types';
import type { UsConsumptionEntry } from '@xbcb/api-gateway-client';

// upsertRelease will be true/false according to this function
export const shouldUpsertRelease = ({
  releaseStatus,
}: UsConsumptionEntry): boolean =>
  releaseStatus === UsCbpEntryReleaseStatus.REJECTED || !releaseStatus;
